import React, { Component } from 'react';
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import { map} from 'lodash';
class JobsLineChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chartWidth: 270
    };
  }

  componentWillMount() {

  }

  componentDidMount() {

  }

  updateWindowDimensions() {

  }

  render() {
    const style = {
      fullWidthGraph: {
        width: '95%',
        height: '50%'
      }, chartLeftPos: {
        top: 10, right: 10, bottom: 0, left: 15
      }, singleChartLeftPos: {
        top: 10, right: 10, bottom: 0, left: -40
      }
    };
    const {commonReducer,title,expiredData,newRequestData,inProgressData,weekActive,monthlyNewRequestData,monthlyExpiredData,monthlyInProgressData} = this.props;
    let currentWeek_newRequestsCount = 0;
    map(commonReducer && commonReducer.currentWeek_openJobs && commonReducer.currentWeek_openJobs["newRequest"],(data)=>{
      if(data){
        currentWeek_newRequestsCount = currentWeek_newRequestsCount + data.count;
      }
    });
    let previousWeek_newRequestsCount = 0;
    map(commonReducer && commonReducer.previousWeek_openJobs && commonReducer.previousWeek_openJobs["newRequest"],(data)=>{
      if(data){
        previousWeek_newRequestsCount = previousWeek_newRequestsCount + data.count;
      }
    });
    let diff_newRequestsLength = currentWeek_newRequestsCount - previousWeek_newRequestsCount;
    let currentWeek_expiredCount = 0;
    map(commonReducer && commonReducer.currentWeek_openJobs && commonReducer.currentWeek_openJobs["expired"],(data)=>{
      if(data){
        currentWeek_expiredCount = currentWeek_expiredCount + data.count;
      }
    });
    let previousWeek_expiredCount = 0;
    map(commonReducer && commonReducer.previousWeek_openJobs && commonReducer.previousWeek_openJobs["expired"],(data)=>{
      if(data){
        previousWeek_expiredCount = previousWeek_expiredCount + data.count;
      }
    });
    let diff_expiredRequestsLength = currentWeek_expiredCount - previousWeek_expiredCount;
    return (
      <div className="col-md-6 mpad0 padLeft0" onClick={this.props.clickHandler}>
        <div className="overview-card">
          <a >
            <i className="mdi mdi-chevron-right" />
            <h5 className="text-wrap">{this.props.title}</h5>
            <ul className = {this.props.customClass?"number-graph list-unstyled "+this.props.customClass:"number-graph list-unstyled"} style={style.fullWidthGraph}>
              {!this.props.onlyChart ? <li className="left-block">
                <label className="number-highlight">{title == "New Requests" ? currentWeek_newRequestsCount : title == "Expired" && currentWeek_expiredCount}</label>
                <span className="variation inc">{title == "New Requests" ? diff_newRequestsLength : title == "Expired" && diff_expiredRequestsLength}
                  <i className={title == "New Requests" ? diff_newRequestsLength >= 0 ? "mdi mdi-menu-up" : "mdi mdi-menu-down" :title == "Expired" && diff_expiredRequestsLength >= 0 ? "mdi mdi-menu-up" : "mdi mdi-menu-down"}/>
                </span>
              </li> : ""}
              <li className={!this.props.onlyChart ? "right-block" : ""} >
                 {this.props.title == "In Progress" && <span className="X-label">Jobs</span>}
                <ResponsiveContainer>
                  <LineChart data={title == "New Requests" ? weekActive ? newRequestData : monthlyNewRequestData : title == "Expired" ? weekActive ? expiredData : monthlyExpiredData : title == "In Progress" ? weekActive ? inProgressData : monthlyInProgressData :{}} margin={this.props.title == "In Progress"? style.chartLeftPos:style.singleChartLeftPos}>
                    <Line type="monotone" dataKey="count" stroke={this.props.title == "In Progress" ? "#50D900" : "#FFBE45"} />
                    <Tooltip dataKey="name" />
                    <XAxis dataKey="name" interval={0} ticks={weekActive ? ['SUN','MON','TUE','WED','THU','FRI','SAT']:['5','10','15','20','25','30']}/>
                    <YAxis />
                  </LineChart>
                </ResponsiveContainer>

                {/* {this.props.title == "In Progress" && <span className="Y-label">Durations (Days)</span>} */}
              </li>
            </ul>
          </a>
        </div>
      </div>
    );
  }
}

export default JobsLineChart;



// WEBPACK FOOTER //
// ./src/components/OpenJobs/JobsLineChart.jsx